<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

const set = defineProps({
  phone: String,
  phoneto: String,
  backendurl: String,
  useTrackingPhone: Boolean,
  subtext: {
    type: String,
    default: 'Консультация бесплатно'
  },
  goal: {
    type: String,
    default: 'OPEN_PHONE'
  },
  tracking: {
    type: Object,
    default: () => ({})
  }
});

const cleanHref = computed(() => {
  const raw = (set.phoneto ?? '').replace(/^tel:/, '');
  const digits = raw.replace(/[^\d+]/g, '');
  return 'tel:' + digits;
})

const ymUid = ref(null)

onMounted(() => {
  try {
    const match = document.cookie.match(/(?:^|; )_ym_uid=([^;]+)/)
    if (match) {
      ymUid.value = decodeURIComponent(match[1])
    }
  } catch (e) {
    // Игнорируем ошибки получения куки
  }
})

function trackPhoneClick() {
  // Цель клика по номеру (по умолчанию OPEN_PHONE)
  // @ts-ignore
  try { window.goal(set.goal); } catch (e) { /* noop */ }

  if (!set.tracking?.visit_uuid || !set.backendurl) {
    // @ts-ignore
    if (import.meta.env.DEV) {
      console.log('❌ Нет url для передачи');
    }
    return;
  }
  // @ts-ignore
  if (import.meta.env.DEV) {
    console.log('📞 Отправка уведомления о событии:', {
      url: set.backendurl
    })
  }
  ;

  function getCsrfToken(): string {
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (meta instanceof HTMLMetaElement) {
      return meta.content;
    }
    return '';
  }

  // Отправляем на сервер
  fetch('/events/phone-click', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': getCsrfToken()
    },
    body: JSON.stringify({
      visit_uuid: set.tracking.visit_uuid,
      url: set.backendurl,
      ym_uid: ymUid.value,
    })
  })
    .then(r => r.json())
    .then(data => {
      // @ts-ignore
      if (import.meta.env.DEV) {
        if (data.success) {
          console.log('✅ Клик на телефон сохранён:', data);
        } else {
          console.warn('⚠️ Ошибка сохранения:', data.error);
        }
      }
    })
    .catch(err => console.error('❌ Ошибка сети:', err));
}
</script>

<template>
  <a :href="cleanHref"
    @click="trackPhoneClick"
    class="phone-btn inline-flex w-full items-center gap-3 py-3 px-5 text-white
           bg-brand-600 hover:bg-brand-700 rounded-xl shadow-lg
           hover:scale-105 transition-all duration-300 cursor-pointer justify-center
           focus:outline-none">
    <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
    </svg>
    <div class="flex flex-col items-center">
      <span :class="set.useTrackingPhone ? 'roistat-phone' : ''"
            class="text-base font-bold whitespace-nowrap leading-tight">{{ set.phone }}</span>
      <span class="text-xs whitespace-nowrap">{{ set.subtext }}</span>
    </div>
  </a>
</template>

<style scoped>
@keyframes pulse-ring {
  0%, 100% { box-shadow: 0 0 0 0 rgba(96, 165, 250, 0.6); }
  50%       { box-shadow: 0 0 0 10px rgba(96, 165, 250, 0); }
}
.phone-btn {
  animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  box-shadow: 0 4px 20px rgba(79, 70, 229, 0.4);
}
</style>
